export default (id: any, props: any) => {
  const { data } = props;
  let inputId = id;
  if (data && data.id) {
    inputId = `${id}/${data.id}`;
  }
  return inputId;
};
